{
  "close": "關閉"
}
